module.exports = __webpack_public_path__ + "1faa151aca158920.svg";